import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { ApiService } from '../../services/api/api.service';
import { FormatService } from '../../services/format/format.service';
import * as moment from 'moment';

declare const exportVoucherImages: any;
declare const exportVoucherPdf: any;
declare const $:any;

@Component({
  selector: 'app-voucher-list',
  templateUrl: './voucher-list.component.html',
  styleUrls: ['./voucher-list.component.css']
})
export class VoucherListComponent implements OnInit {

  showFormAdd: any = { 'isFormSearch': 2, 'isType': 'add',};
  isForm : any;
  isDetailData : any ;
  isData : any = [];
  isDetail : any = [];
  isAmountVoucher : any = [];
  isOffset: number = 0;
  isTotalVw : number = 0;
  isTotalAll : number = 0;

  isKeyword : string = '';
  isType : string = '';
  isStatus : string = '';

  isGrouped : any = [];
  isExpanded : any = {};
  isPrintList : any = [];
  isPreviewList : any = [];
  isPrintName : string = '';
  isPrintFormat : string = 'pdf';
  isExporting : boolean = false;
  isExportDone : number = 0;
  isExportTotal : number = 0;
  isPage : number = 1;
  isPageSize : number = 10;
  isPages : any = [];
  isTableLoading : boolean = false;

  dataBackground : any = [];
  dataType : any = [{'id':0,'text':'Unik'},{'id':1,'text':'Masal'}];
  dataStatus : any = [{'id':1,'text':'Aktif'},{'id':0,'text':'Nonaktif'}];
  dataJenis : any = [{'id':false,'text':'Digital'},{'id':true,'text':'Cetak (fisik)'}];

  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private authService: AuthenticationService,
    private apiService: ApiService,
    private formatService: FormatService,
  ) { }

  ngOnInit(): void {
    this.isPageSize = this.apiService.LIMIT || 10;
    this.getData();
    this.resetForm();
    this.getBackground();
  }
  async resetForm(){
    this.isForm = this.fb.group({
      id : new FormControl(''),
      admin_id : new FormControl(this.authService.getSession().id),
      name : new FormControl('', [Validators.required]),
      code : new FormControl('', [Validators.required]),
      amount : new FormControl('', [Validators.required]),
      price : new FormControl('', [Validators.required]),
      expired_day : new FormControl('', [Validators.required]),
      type : new FormControl('', [Validators.required]),
      status : new FormControl('', [Validators.required]),
      is_printed : new FormControl(false, [Validators.required]),
      voucher_background_id : new FormControl('', [Validators.required]),
    })
  }
  async getBackground(){
    try{
      this.apiService.methodGetSilent(`voucher-background/list`,this.authService.getToken()).subscribe((response)=>{
        if(response && response.status == 200) {
          this.dataBackground = response.data;
        }
      })
    }catch(error){
      console.log(error);
    }
  }
  async onReset() {
    this.isData    = await [];
    this.isDetail    = await [];
    this.isGrouped = [];
    this.isExpanded = {};
    this.isPage = 1;
    this.isOffset = await 0;
    this.isTotalVw = await 0;
    this.isTotalAll = await 0;
    this.isKeyword = await '';
    this.isType = await '';
    this.isStatus = await '';
    await this.resetForm();
    await this.getData();
  }
  private searchTimer : any;
  private lastQuery : string = '';

  onKeywordInput(value : string){
    this.isKeyword = value;
    clearTimeout(this.searchTimer);
    // debounce: wait 450ms after the last keystroke before hitting the API
    this.searchTimer = setTimeout(() => this.applyFilter(), 450);
  }

  async applyFilter(){
    clearTimeout(this.searchTimer);
    const query = `${this.isKeyword}|${this.isType}|${this.isStatus}`;
    if(query === this.lastQuery){ return; } // query unchanged, skip the request
    this.lastQuery = query;
    this.isPage = 1;
    this.isExpanded = {};
    this.isGrouped = [];
    await this.getData();
  }
  async onSearch($event: any){
    this.isData    = await [];
    this.isDetail    = await [];
    this.isPage = 1;
    this.isExpanded = {};
    this.isOffset = await 0;
    this.isTotalVw = await 0;
    this.isTotalAll = await 0;
    this.isKeyword = await ($event['keyword']?$event['keyword']:'');
    this.isType = await ($event['type']?$event['type']:'');
    this.isStatus = await ($event['status']?$event['status']:'');
    this.getData();
  }
  isConfirm : any = null; // {mode: 'single', v} | {mode: 'group', g}

  onDelete(v:any){
    this.openConfirm({mode: 'single', v: v});
  }

  private openConfirm(c: any){
    this.isConfirm = c;
    document.body.style.overflow = 'hidden'; // lock the page scroll behind the dialog
    setTimeout(() => { // focus the Cancel button so the keyboard lands inside the dialog
      const btn: any = document.querySelector('.hds-dialog .vl-btn-ghost');
      if(btn){ btn.focus(); }
    });
  }

  isDeleting : boolean = false;

  closeConfirm(){
    if(this.isDeleting){ return; } // never close while a deletion is in flight
    this.isConfirm = null;
    document.body.style.overflow = '';
  }

  @HostListener('document:keydown.escape')
  onEscapeConfirm(){
    if(this.isConfirm){ this.closeConfirm(); }
  }

  // reload without discarding filters/page; step back one page if this page becomes empty
  async refreshAfterDelete(){
    this.isGrouped = [];
    this.isExpanded = {};
    await this.getData();
    if(this.isData.length === 0 && this.isPage > 1){
      this.isPage = this.isPage - 1;
      await this.getData();
    }
  }

  async confirmDelete(){
    const c = this.isConfirm;
    if(!c || this.isDeleting){ return; }
    this.isDeleting = true;
    const request = c.mode === 'single'
      ? this.apiService.methodDeleteSilent(`voucher/${c.v.id}`, this.authService.getToken())
      : this.apiService.methodPostSilent(`voucher/bulk-delete`, {name: c.g.name, background_id: c.g.bgId}, this.authService.getToken());
    request.subscribe(async (response)=>{
      this.isDeleting = false;
      if(response && response.status == 200) {
        this.closeConfirm();
        if(c.mode === 'single'){
          await this.toastr.success(`${c.v.code} — ${c.v.name}`, `Voucher dihapus`);
        }else{
          await this.toastr.success(response.message || `${this.formatNumber(c.g.count)} voucher dihapus`, `Grup "${c.g.name}" dihapus`);
        }
        this.refreshAfterDelete();
      } else {
        // failure: keep the dialog open so the user can retry
        await this.toastr.error((response && response.message) || `Coba lagi beberapa saat.`, `Gagal menghapus`);
      }
    }, async () => {
      this.isDeleting = false;
      await this.toastr.error(`Periksa koneksi lalu coba lagi.`, `Gagal menghapus`);
    });
  }
  async getData(){
    let searchData = {"keyword":this.isKeyword,"type":this.isType,"status":this.isStatus};
    const offset = (this.isPage - 1) * this.isPageSize;
    this.isTableLoading = true;
    try{
      this.apiService.methodGetSilent(`voucher/${offset}/${encodeURIComponent(JSON.stringify(searchData))}`,this.authService.getToken()).subscribe((response)=>{
        this.isTableLoading = false;
        if(response && response.status == 200) {
          this.isData = [];
          (response.total ? response.data.forEach((element: any) => {
            // background can be null when deleted — must never break the render
            if(element.voucher_background){
              element.voucher_background.image = `${response.directoryFile}voucher/${element.voucher_background.image}`;
            }else{
              element.voucher_background = {name: '-', image: ''};
            }
            this.isData.push(element);
          }) : false);
          this.isTotalVw = this.isData.length;
          this.isTotalAll = response.total || 0;
          this.buildGroups();
          this.buildPager();
        }
      }, () => { this.isTableLoading = false; })
    }catch(error){
      this.isTableLoading = false;
      console.log(error);
    }
  }
  totalPages(){
    return Math.max(1, Math.ceil(this.isTotalAll / this.isPageSize));
  }
  buildPager(){
    const total = this.totalPages();
    const pages: any[] = [];
    for(let p = 1; p <= total; p++){
      if(p == 1 || p == total || Math.abs(p - this.isPage) <= 1){
        pages.push(p);
      }else if(pages[pages.length - 1] != '...'){
        pages.push('...');
      }
    }
    this.isPages = pages;
  }
  async goToPage(p: any){
    const total = this.totalPages();
    if(p < 1 || p > total || p == this.isPage){ return; }
    this.isPage = p;
    await this.getData();
  }
  rowNo(i: number){
    return (this.isPage - 1) * this.isPageSize + i + 1;
  }
  summaryFrom(){
    return this.isTotalAll ? (this.isPage - 1) * this.isPageSize + 1 : 0;
  }
  summaryTo(){
    return (this.isPage - 1) * this.isPageSize + this.isData.length;
  }
  buildGroups(){
    const prevGroups = this.isGrouped;
    this.isGrouped = this.isData.map((v: any) => {
      if(v.type == 0 && v.group_count > 1){
        const key = `${v.name}|${v.voucher_background_id}`; // group = name + background
        const prev = prevGroups.find((p: any) => p.isGroup && p.key == key);
        const g = {isGroup: true, key: key, name: v.name, bgId: v.voucher_background_id,
                   header: v, count: v.group_count, items: (prev ? prev.items : []), visible: []};
        this.applyItemFilter(g); // cached members must respect the current keyword too
        return g;
      }
      return {isGroup: false, v: v};
    });
    // an active search means the user is looking for something specific —
    // open every matching row right away instead of making them click each one
    if(this.isKeyword.trim()){
      this.isGrouped.forEach((g: any) => {
        if(g.isGroup){
          this.isExpanded[g.key] = true;
          if(!g.items.length){ this.loadGroupItems(g); }
        }else{
          this.isExpanded['s' + g.v.id] = true;
        }
      });
    }
  }
  loadGroupItems(g: any){
    g.loading = true;
    return new Promise<void>((resolve) => {
      this.apiService.methodGetSilent(`voucher/group-items/${encodeURIComponent(g.name)}/${g.bgId}`, this.authService.getToken()).subscribe((response) => {
        if(response && response.status == 200){
          response.data.forEach((element: any) => {
            if(element.voucher_background){
              element.voucher_background.image = `${response.directoryFile}voucher/${element.voucher_background.image}`;
            }else{
              element.voucher_background = {name: '-', image: ''};
            }
          });
          g.items = response.data;
          this.applyItemFilter(g);
        }
        g.loading = false;
        resolve();
      }, () => { g.loading = false; resolve(); });
    });
  }
  toggleSingle(g: any){
    this.isExpanded['s' + g.v.id] = !this.isExpanded['s' + g.v.id];
  }
  async toggleGroup(g: any){
    if(!this.isExpanded[g.key] && !g.items.length){
      await this.loadGroupItems(g);
    }
    this.isExpanded[g.key] = !this.isExpanded[g.key];
  }
  async onShowAdd(){
    this.resetForm();
    $('#formData').modal({backdrop: 'static', keyboard: false})
  }
  // show inline errors once a field is touched / after a submit attempt
  isInvalid(control : string){
    const c = this.isForm.get(control);
    return c && c.invalid && (c.touched || c.dirty);
  }

  async onSubmit(){
    try{
      if(this.isForm.invalid){
        this.isForm.markAllAsTouched();
        return;
      }
      this.isLoading = true;
      // getRawValue: includes disabled controls (code/type/amount while editing)
      const payload = this.isForm.getRawValue();
      payload.price = this.unformat(payload.price);
      payload.amount = this.unformat(payload.amount);
      payload.expired_day = this.unformat(payload.expired_day);
      const isEdit = !!payload.id;
      const request = isEdit
        ? this.apiService.methodPutSilent(`voucher/${payload.id}`, payload, this.authService.getToken())
        : this.apiService.methodPostSilent(`voucher`, payload, this.authService.getToken());
      request.subscribe(async(response)=>{
        this.isLoading = false;
        if (response && response.status == 200) {
          // close the modal only on success — on failure the user's input stays intact
          $('#formData').modal('hide');
          await this.toastr.success(
            `${payload.name}${(!isEdit && payload.type == 0) ? ' — ' + this.formatNumber(payload.amount) + ' kode diterbitkan' : ''}`,
            isEdit ? `Voucher diupdate` : `Voucher dibuat`);
          await this.onReset();
        } else {
          await this.toastr.error((response && response.message) || `Periksa isian lalu coba lagi.`, `Gagal menyimpan`);
        }
      }, async () => {
        this.isLoading = false;
        await this.toastr.error(`Periksa koneksi lalu coba lagi.`, `Gagal menyimpan`);
      });
    }catch(error){
      this.isLoading = false;
      await this.toastr.error(error.message || `Gagal menyimpan data`);
    }
  }
  async onEdit(v:any){
    try{
      this.resetForm();
      const dataEdit: any = Object.assign({}, v);
      await this.isForm.patchValue(dataEdit);
      this.isForm.patchValue({
        price: this.formatService.dotFormat(dataEdit.price || 0),
        amount: this.formatService.dotFormat(dataEdit.amount || 0),
        expired_day: this.formatService.dotFormat(dataEdit.expired_day || 0),
        is_printed: !!(dataEdit.is_printed === true || dataEdit.is_printed === 1),
      });
      // while editing: type is always locked; amount is locked for unique vouchers.
      // code is locked only once someone has actually redeemed it — otherwise editing it
      // would retroactively change what's shown on already-issued redemptions
      // (see "Berlangganan > Voucher", which joins live to this row's code).
      // disabled controls are exempt from validation (values still available via getRawValue)
      if(Number(dataEdit.used_count) > 0){ this.isForm.get('code').disable(); }
      this.isForm.get('type').disable();
      if(dataEdit.type == 0){ this.isForm.get('amount').disable(); }
      this.isForm.controls['code'].updateValueAndValidity();
      // keyboard: false — Escape must never dismiss the dialog mid-save
      await $('#formData').modal({ backdrop: 'static', keyboard: false, show: true });
    }catch(error){
      console.log(error);
    }
  }

  formatPrice(value : any){
    return this.formatService.currency(value || 0);
  }

  // per-code status for UNIK vouchers — MASAL keeps the plain Aktif/Nonaktif pill,
  // since one MASAL row is shared by many redemptions and "terpakai" doesn't apply to it
  voucherStatusLabel(v : any){
    if(Number(v.status) !== 1){ return 'Nonaktif'; }
    if(!(Number(v.used_count) > 0)){ return 'Belum Terpakai'; }
    if(v.active_expired && new Date(v.active_expired) >= new Date()){ return 'Terpakai - Aktif'; }
    return 'Kadaluarsa';
  }

  voucherStatusClass(v : any){
    const label = this.voucherStatusLabel(v);
    if(label === 'Belum Terpakai'){ return 'off'; }
    if(label === 'Terpakai - Aktif'){ return 'on'; }
    if(label === 'Kadaluarsa'){ return 'warn'; }
    return 'off';
  }

  // format numeric input while typing: 50000 -> 50.000 (digits only),
  // caret position is preserved so it doesn't jump to the end when editing mid-value
  onNumberInput(event : any, control : string){
    const input = event.target;
    const raw = String(input.value || '');
    const caret = input.selectionStart || 0;
    const digitsBeforeCaret = raw.slice(0, caret).replace(/\D/g, '').length;
    const digits = raw.replace(/\D/g, '');
    const formatted = digits ? this.formatService.dotFormat(parseInt(digits, 10)) : '';
    this.isForm.patchValue({[control]: formatted}, {emitEvent: false});
    input.value = formatted;
    let pos = 0, count = 0;
    while(pos < formatted.length && count < digitsBeforeCaret){
      if(/\d/.test(formatted[pos])){ count++; }
      pos++;
    }
    input.setSelectionRange(pos, pos);
  }

  // convert a dot-formatted value back to a plain number
  private unformat(value : any){
    return parseInt(String(value).replace(/\./g, '')) || 0;
  }

  formatNumber(value : any){
    return this.formatService.dotFormat(value || 0);
  }

  // wrap keyword matches in <mark> for the list; input is HTML-escaped first
  highlight(text : any){
    const esc = String(text == null ? '' : text)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const keyword = this.isKeyword.trim();
    if(!keyword){ return esc; }
    const escapedKeyword = keyword
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // neutralize regex metacharacters
    return esc.replace(new RegExp(`(${escapedKeyword})`, 'gi'), '<mark class="vl-hl">$1</mark>');
  }

  // during a keyword search only matching codes stay visible; if none of the
  // codes match (the group matched by name), the whole list is relevant
  private applyItemFilter(g : any){
    const keyword = this.isKeyword.trim().toLowerCase();
    if(!keyword){ g.visible = g.items; return; }
    const matched = g.items.filter((it : any) => String(it.code || '').toLowerCase().indexOf(keyword) >= 0);
    g.visible = matched.length ? matched : g.items;
  }

  copyCode(code : string){
    const done = () => this.toastr.success(`Kode ${code} disalin`);
    const nav: any = navigator;
    if(nav.clipboard && nav.clipboard.writeText){
      nav.clipboard.writeText(code).then(done);
    }else{
      const ta = document.createElement('textarea');
      ta.value = code;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      done();
    }
  }

  // uppercase the actual code value (CSS uppercase is visual only; the value stays lowercase)
  onCodeInput(event : any){
    const upper = String(event.target.value || '').toUpperCase();
    this.isForm.patchValue({code: upper}, {emitEvent: false});
    event.target.value = upper;
  }

  async validationCode(code : any){
    if(code.target.value){
      if(code.target.value.length > 10){
        this.toastr.error(`Maksimal 10 karakter !!`);
      }
    }
  }

  async viewVoucher(v : any){
    this.isDetail = v;
    // masal and single unik alike: one code, one card is enough
    this.openPrintModal([v], `${v.code} - Aktif ${v.expired_day} Hari`);
  }

  async viewVoucherGroup(g : any){
    if(!g.items.length){
      await this.loadGroupItems(g);
    }
    if(!g.items.length){
      this.toastr.error(`Gagal memuat isi grup`);
      return;
    }
    this.isDetail = g.items[0];
    this.openPrintModal(g.items, `${g.name} - ${g.items.length} Voucher - Aktif ${g.items[0].expired_day} Hari`);
  }

  openPrintModal(list : any[], printName : string){
    this.isPrintList = list;
    this.isPreviewList = list.slice(0, 5); // a small preview is enough — same design, only the codes differ
    this.isPrintName = printName;
    this.isPrintFormat = 'pdf';
    $("#modalVoucher").modal("show");
  }

  setPrintFormat(f : string){
    this.isPrintFormat = f;
  }
  itemFileName(v : any){
    return `${v.code} - Aktif ${v.expired_day} Hari`;
  }
  printIsZip(){
    return this.isPrintFormat !== 'pdf' && this.isPrintList.length > 1;
  }
  printBadge(){
    return this.printIsZip() ? 'ZIP' : this.isPrintFormat.toUpperCase();
  }
  printFileName(){
    if(this.isPrintFormat === 'pdf'){ return `${this.isPrintName}.pdf`; }
    if(this.printIsZip()){ return `${this.isPrintName}.zip`; }
    return `${this.itemFileName(this.isPrintList[0])}.${this.isPrintFormat}`;
  }
  printDesc(){
    const n = this.formatNumber(this.isPrintList.length);
    if(this.isPrintFormat === 'pdf'){
      return this.isPrintList.length > 1 ? `1 file PDF berisi ${n} kartu` : `1 halaman PDF`;
    }
    const f = this.isPrintFormat.toUpperCase();
    return this.printIsZip() ? `${n} gambar ${f} dalam satu ZIP` : `1 gambar ${f}`;
  }
  printSub(){
    if(this.isPrintFormat === 'pdf'){
      return this.isPrintList.length > 1
        ? `2 kartu per baris, otomatis berganti halaman.`
        : `Satu kartu voucher dalam dokumen.`;
    }
    if(this.printIsZip()){
      return `Tiap kartu jadi satu file: "${this.itemFileName(this.isPrintList[0])}.${this.isPrintFormat}", dst.`;
    }
    return `Resolusi tinggi (render 4×), siap dikirim via chat.`;
  }
  exportButtonLabel(){
    if(this.isExporting){
      if(this.isExportTotal > 1){
        if(this.isExportDone >= this.isExportTotal){
          return this.isPrintFormat === 'pdf' ? `Menyusun PDF…` : `Mengemas ZIP…`;
        }
        return `Merender ${this.isExportDone}/${this.isExportTotal}…`;
      }
      return this.isPrintFormat === 'pdf' ? `Membuat PDF…` : `Menyiapkan…`;
    }
    if(this.isPrintFormat === 'pdf'){ return 'Unduh PDF'; }
    const f = this.isPrintFormat.toUpperCase();
    return this.printIsZip() ? `Unduh ${f} (.zip)` : `Unduh ${f}`;
  }

  async onExport(){
    if(this.isExporting){ return; }
    this.isExporting = true;
    this.isExportDone = 0;
    this.isExportTotal = this.isPrintList.length;
    await new Promise(resolve => setTimeout(resolve, 60)); // give the spinner time to paint first
    try{
      const items = this.isPrintList.map((v: any) => ({
        image: v.voucher_background.image,
        text: `${v.code} - Aktif: ${v.expired_day} Hari`,
        name: this.itemFileName(v),
      }));
      const progress = (done: number) => { this.isExportDone = done; };
      if(this.isPrintFormat === 'pdf'){
        await exportVoucherPdf(items, `${this.isPrintName}.pdf`, progress);
        await this.toastr.success(`${this.printFileName()}`, `Ekspor selesai`);
      }else{
        await exportVoucherImages(this.isPrintFormat, items, this.isPrintName, progress);
        await this.toastr.success(this.printIsZip()
          ? `${this.formatNumber(items.length)} gambar dikemas dalam ZIP`
          : `${this.printFileName()}`, `Ekspor selesai`);
      }
    }catch(error){
      await this.toastr.error(`Coba lagi beberapa saat.`, `Gagal mengekspor`);
    }
    this.isExporting = false;
  }

  onDeleteGroup(g : any){
    this.openConfirm({mode: 'group', g: g});
  }


  async getBase64ImageFromUrl(imageUrl) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();

    return new Promise((resolve, reject) => {
      var reader  = new FileReader();
      reader.addEventListener("load", function () {
          resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }
}
